var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2975 99.0275L110 72.325L136.716 99.0413L152.254 83.5037L110 41.25L67.76 83.49L83.2975 99.0275ZM41.25 110L56.7875 94.4625L72.325 110L56.7875 125.537L41.25 110ZM83.2975 120.973L110 147.675L136.716 120.959L152.254 136.489L110 178.75L67.76 136.51L67.7394 136.489L83.2975 120.973ZM147.675 110L163.213 94.4625L178.75 110L163.213 125.537L147.675 110ZM125.757 109.986H125.771V110L110 125.771L94.2494 110.027L94.2219 110L94.2494 109.979L97.0062 107.216L98.3469 105.875L110 94.2288L125.764 109.993L125.757 109.986Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.f7ce365e53c35474fda54f01b09d4713.svg";
export { ForwardRef as ReactComponent };